import ReduxModalForm from './ReduxModalForm';

export default ReduxModalForm;
